import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { mapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import { type AppState } from '../../app.store';
import { activePlaceStateSelector } from '../activeMapElements/activeMapElements.selectors';

export const placesSearchResultsSelector = (state: AppState) => state.frontendState.places.searchResults;
export const usePlacesSearchResultsSelector = () => useSelector(placesSearchResultsSelector);

const placesSearchExpandedSearchesSelector = (state: AppState) => state.frontendState.places.expandedSearchIds;
export const usePlacesSearchExpandedSearchesSelector = () => useSelector(placesSearchExpandedSearchesSelector);

const placesStartingLocationSelector = (state: AppState) => state.frontendState.places.startingLocation;
export const usePlacesStartingLocationSelector = () => useSelector(placesStartingLocationSelector);

const placesSearchTermSelector = (state: AppState) => state.frontendState.places.searchTerm;
export const usePlacesSearchTermSelector = () => useSelector(placesSearchTermSelector);

const placesHoveredSearchIdSelector = (state: AppState) => state.frontendState.places.hoveredSearchId;
export const usePlacesHoveredSearchIdSelector = () => useSelector(placesHoveredSearchIdSelector);

const placesHoveredPlaceInListSelector = (state: AppState) => state.frontendState.places.hoveredPlaceInList;
export const usePlacesHoveredPlaceInListSelector = () => useSelector(placesHoveredPlaceInListSelector);

const activePlaceSelector = createStateSelector([
  activePlaceStateSelector,
  mapSettingsPlacesSearchesSelector,
], (activePlaceState, placeSearches) => {
  if (!activePlaceState) {
    return null;
  }
  const search = placeSearches.find(ps => ps.id === activePlaceState.placeSearchId);
  if (!search || search.removedPlaces?.includes(activePlaceState.id)) {
    return null;
  }
  return activePlaceState;
});
export const useActivePlaceSelector = () => useSelector(activePlaceSelector);
